import React from "react"
import Card from "components/card"
import Input from "components/forms/input"
import GeneralForm from "./general-form"
import LegalForm from "./legal-form"
import ShopifyForm from "./shopify-form"
import StripeForm from "./stripe-form"

const BrandForm = ({ brand, refetchBrand }) => {
  const {
    name,
    key,
    homepage,
    shopifyDomain,
    applicationFeeRate,
    termsOfUseUrl,
    privacyPolicyUrl,
    supportUrl,
    shopifyApiKey,
    shopifyApiSecret,
    shopifyMerchantInstallLink,
    shopifyMerchantInstallLinkExpiresAtDistance,
    shopifyMerchantInstallLinkExpiresAt,
    stripeInstallLink,
    stripeConnectAccountId,
    hasShopifyToken,
    dropboxFileRequestLink,
    publicRefreshToken,
    logoImageSrc: faviconSrc,
    logoHorizontalSrc,
    onboardingStripeSetupComplete,
    onboardingShopifySetupComplete,
    onboardingCalendlyComplete,
    applePayOnWebEnabled,
  } = brand

  const getOnboboardingLink = () => {
    if (!shopifyApiKey || !shopifyApiSecret || !shopifyMerchantInstallLink) {
      return "Shopify Install Link Required"
    }

    if (shopifyMerchantInstallLinkExpiresAt < new Date()) {
      return "Shopify Install Link Expired"
    }

    return `https://app.getbatch.com/onboarding/${publicRefreshToken}`
  }

  return (
    <div className="flex flex-col max-w-4xl">
      <Card className="flex flex-col gap-3">
        <h3 className="flex-1 text-lg mb-6 font-semibold">Onboarding</h3>
        <Input
          isTextOnly
          label="Onboarding Page Link (Not modifiable)"
          name="onboardingPageLink"
          value={getOnboboardingLink()}
        />
        <p className="text-sm uppercase text-red-600">
          Onboarding link is not yet ready to be shared. Please do not share
          this link externally.
        </p>
        <Input
          color={
            onboardingStripeSetupComplete ? "text-green-400" : "text-red-400"
          }
          isTextOnly
          label="Stripe"
          value={onboardingStripeSetupComplete ? "Complete" : "Incomplete"}
        />
        <Input
          color={
            onboardingShopifySetupComplete ? "text-green-400" : "text-red-400"
          }
          isTextOnly
          label="Shopify"
          value={onboardingShopifySetupComplete ? "Complete" : "Incomplete"}
        />
        <Input
          color={onboardingCalendlyComplete ? "text-green-400" : "text-red-400"}
          isTextOnly
          label="Calendly"
          value={onboardingCalendlyComplete ? "Complete" : "Incomplete"}
        />
      </Card>

      <GeneralForm
        faviconSrc={faviconSrc}
        homepage={homepage}
        logoHorizontalSrc={logoHorizontalSrc}
        name={name}
        refetchBrand={refetchBrand}
        urlKey={key}
      />

      <Card>
        <h3 className="flex-1 text-lg mb-6 font-semibold">Dropbox</h3>
        {dropboxFileRequestLink && (
          <Input
            isTextOnly
            label="Dropbox Asset Folder (Not modifiable)"
            name="dropboxAssetLink"
            value={`https://www.dropbox.com/home/BrandAssetRequest/${name}`}
          />
        )}
        <Input
          hint="The file request link is auto-generated. It is not modifiable."
          isTextOnly
          label="Asset Request Link (Not modifiable)"
          name="dropboxFileRequestLink"
          showCopyButton
          value={dropboxFileRequestLink}
        />
      </Card>

      <LegalForm
        privacyPolicyUrl={privacyPolicyUrl}
        refetchBrand={refetchBrand}
        supportUrl={supportUrl}
        termsOfUseUrl={termsOfUseUrl}
      />

      <StripeForm
        applePayOnWebEnabled={applePayOnWebEnabled}
        applicationFeeRate={applicationFeeRate}
        refetchBrand={refetchBrand}
        stripeConnectAccountId={stripeConnectAccountId}
        stripeInstallLink={stripeInstallLink}
      />

      <ShopifyForm
        hasShopifyToken={hasShopifyToken}
        refetchBrand={refetchBrand}
        shopifyApiKey={shopifyApiKey}
        shopifyApiSecret={shopifyApiSecret}
        shopifyDomain={shopifyDomain}
        shopifyMerchantInstallLink={shopifyMerchantInstallLink}
        shopifyMerchantInstallLinkExpiresAtDistance={
          shopifyMerchantInstallLinkExpiresAtDistance
        }
      />
    </div>
  )
}

export default BrandForm
